<template>
    <div class="homeworkPage">
        <div class="testPaperBox" v-if="testPaper">
            <h2>{{ testPaper.testName }}</h2>
            <h3 class="score" v-if="testPaper.totalScore">{{`共得分：${testPaper.totalScore}分`}}</h3>
            <div class="singleQuestions" v-if="testPaper.singleChoiceQuestionNum">
                <h3>{{`单选题（共 ${testPaper.singleChoiceQuestionNum} 道题）`}}</h3>
                <div class="singleQuestionsBox">
                    <div
                     class="questions"
                     v-for="(single, index) in testPaper.singleChoiceQuestions"
                     :key="index">
                        <i class="el-icon-check" v-if="single.checkStatus == '正确'"></i>
                        <i class="el-icon-close" v-if="single.checkStatus == '错误'"></i>
                        <div>
                            <div class="questionsTitle">
                                <span>{{ `${index + 1}.` }}</span>
                                <span v-html="` ${single.title}`" class="title"></span>
                                <span v-if="single.getQuestionScore">{{`（得分：${single.getQuestionScore}分）`}}</span>
                            </div>
                            <div class="singleOption">
                                <el-radio-group v-model="single.stuOptionId" :disabled="disabled">
                                    <el-radio
                                     :label="option.id"
                                     :class="option.isSelect? 'colorCheck' : ''"
                                     v-for="(option, optionIndex) in single.options"
                                     :key="optionIndex">
                                        {{ optionsMap[optionIndex] }}
                                        <span v-html="`${option.option}`"></span> 
                                    </el-radio>
                                </el-radio-group>
                                <!-- <span
                                ></span> -->
                            </div>
                            <div v-if="single.checkStatus == '错误'">
                                <span
                                 class="successAnswer"
                                 v-for="(option, optionIndex) in single.options"
                                 :key="optionIndex"
                                 v-show="option.id == single.optionId">{{ `正确答案：${optionsMap[optionIndex]}` }}</span>
                            </div>
                            <div v-if="single.description && single.checkStatus != '未做'" class="analysis">{{ `【解析】：${single.description}` }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="multipleQuestions" v-if="testPaper.multipleChoiceQuestionNum">
                <h3>{{`多选题（共 ${testPaper.multipleChoiceQuestionNum} 道题）`}}</h3>
                <div class="multipleQuestionsBox">
                    <div
                     class="questions"
                     v-for="(multiple, index) in testPaper.multipleChoiceQuestions"
                     :key="index">
                        <i class="el-icon-check" v-if="multiple.checkStatus == '正确'"></i>
                        <i class="el-icon-close" v-if="multiple.checkStatus == '错误'"></i>
                        <div>
                            <div class="questionsTitle">
                                <span>{{ `${index + 1}.` }}</span>
                                <span v-html="`${multiple.title}`"></span>
                                <span v-if="multiple.getQuestionScore">{{`（得分：${multiple.getQuestionScore}分）`}}</span>
                            </div>
                            <div class="multipleOption">
                                <el-checkbox-group v-model="multiple.stuOptionIds" :disabled="disabled">
                                    <el-checkbox
                                     :label="option.id"
                                     :class="option.isSelect? 'colorCheck' : ''"
                                     v-for="(option, optionIndex) in multiple.options"
                                     :key="optionIndex">
                                        {{ optionsMap[optionIndex] }}
                                        <span v-html="`${option.option}`"></span> 
                                    </el-checkbox>
                                </el-checkbox-group>
                                <!-- <span
                                :class="option.isSelect? 'colorCheck' : ''"
                                v-for="(option, optionIndex) in multiple.options"
                                :key="optionIndex"
                                v-html="`${optionsMap[optionIndex]}.${option.option}`"></span> -->
                            </div>
                            <span
                             v-if="multiple.checkStatus == '错误'"
                             class="successAnswer">{{ `正确答案：${multiple.succeedOption.join(" ")}` }}</span>
                            <div v-if="multiple.description && multiple.checkStatus != '未做'" class="analysis">{{ `【解析】：${multiple.description}` }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="gapFillingQuestions" v-if="testPaper.gapFillingQuestionNum">
                <h3>{{`填空题（共 ${testPaper.gapFillingQuestionNum} 道题）`}}</h3>
                <div class="gapFillingQuestionsBox">
                    <div
                     class="questions"
                     v-for="(gapFilling, index) in testPaper.gapFillingQuestions"
                     :key="index">
                        <i class="el-icon-check" v-if="gapFilling.checkStatus == '正确'"></i>
                        <i class="el-icon-close" v-if="gapFilling.checkStatus == '错误'"></i>
                        <div>
                            <div class="questionsTitle">
                                <span>{{ `${index + 1}.` }}</span>
                                <span v-html="`${gapFilling.title}`"></span>
                                <span v-if="gapFilling.getQuestionScore">{{`（得分：${gapFilling.getQuestionScore}分）`}}</span>
                            </div>
                            <div class="gapFillingOption">
                                <div
                                 class="gapFillingOptionBox"
                                 v-for="(option, gapFillingIndex ) in gapFilling.stuGapFilling"
                                 :key="gapFillingIndex">
                                    <span>{{`填空${gapFillingIndex+1}：`}}</span>
                                    <el-input :disabled="disabled" v-model="gapFilling.stuGapFilling[gapFillingIndex]" placeholder="请填写"></el-input>
                                </div>
                            </div>
                            <div
                             class="judgeSuccessAnswer"
                             v-if="gapFilling.checkStatus == '错误'"
                             >
                                <span>正确答案：</span>
                                <span
                                 v-for="(suitem, suIndex) in gapFilling.gapFilling"
                                 :key="suIndex">{{ `填空${suIndex + 1}: ${suitem[0]}` }}</span>
                            </div>
                            <div v-if="gapFilling.description && gapFilling.checkStatus != '未做'" class="analysis">{{ `【解析】：${gapFilling.description}` }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="judgeQuestions" v-if="testPaper.judgeQuestionNum">
                <h3>{{`判断题（共 ${testPaper.judgeQuestionNum} 道题）`}}</h3>
                <div class="judgeQuestionsBox">
                    <div
                     class="questions"
                     v-for="(judge, index) in testPaper.judgeQuestions"
                     :key="index">
                        <i class="el-icon-check" v-if="judge.checkStatus == '正确'"></i>
                        <i class="el-icon-close" v-if="judge.checkStatus == '错误'"></i>
                        <div>
                            <div class="questionsTitle">
                                <span>{{ `${index + 1}.` }}</span>
                                <span v-html="`${judge.title}`"></span>
                                <span v-if="judge.getQuestionScore">{{`（得分：${judge.getQuestionScore}分）`}}</span>
                            </div>
                            <div class="judgeOption">
                                <el-radio-group v-model="judge.stuAnswer" :disabled="disabled">
                                    <el-radio label="正确">正确</el-radio>
                                    <el-radio label="错误">错误</el-radio>
                                </el-radio-group>
                                <!-- <i class="el-icon-circle-check" :class="judge.stuAnswer == '正确'? 'colorCheck' : ''"></i>
                                <i class="el-icon-circle-close" :class="judge.stuAnswer == '错误'? 'colorCheck' : ''"></i> -->
                            </div>
                            <span
                             class="successAnswer"
                             v-if="judge.checkStatus == '错误'">正确答案：<i :class="judge.answer == '正确'? 'el-icon-circle-check' : 'el-icon-circle-close'"></i></span>
                            <div v-if="judge.description && judge.checkStatus != '未做'" class="analysis">{{ `【解析】：${judge.description}` }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="comprehensiveQuestions" v-if="testPaper.comprehensiveQuestionNum">
                <h3>{{`问答题（共 ${testPaper.comprehensiveQuestionNum} 道题）`}}</h3>
                <div class="comprehensiveQuestionsBox">
                    <div
                     v-for="(comprehensive, index) in testPaper.comprehensiveQuestions"
                     :key="index">
                        <span class="questionsBox" v-html="`${index + 1}. ${comprehensive.title}`"></span>
                        <div class="comprehensiveOption">
                            <el-input
                             type="textarea"
                             :autosize="{ minRows: 10}"
                             resize="none"
                             :disabled="disabled"
                             v-model="comprehensive.stuAnswer">
                            </el-input>
                        </div>
                    </div>
                </div>
            </div>
            <el-row type="flex" justify="center" style="margin: 25px 0" v-if="testPaper.comprehensiveQuestionNum || testPaper.gapFillingQuestionNum || testPaper.multipleChoiceQuestionNum || testPaper.singleChoiceQuestionNum">
                <el-button type="primary" :disabled="disabled" @click="submit">提交习题</el-button>
            </el-row>
        </div>
    </div>
</template>
<script>
import classAwayApi from '@/request/api/classAway';
export default {
    props: {
        testId: {
            type: String,
            default: null
        },
        testIndex: {
            type: Number,
            default: 0
        },
        classRecordId: {
            type: String,
            default: ""
        },
    },
    data() {
        return {
            disabled: false,
            testPaper: {},
            activeNames: ['1', '2', '3', '4'],
            optionsMap: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I'], //选项映射
            answerShow: false, //答案显隐
            accuracyRate: "", //正确率
            loadingHide: false,
        }
    },
    created() {
        this.getHomework();
        console.log(this.classRecordId, this.testId)
    },
    methods: {
        //获取当前课的课后作业
        getHomework() {
            console.log(this.testId, this.classRecordId)
            if(this.testId && this.classRecordId) {
                console.log(this.classRecordId)
                let params = {
                    classRecordId: this.classRecordId,
                    resourceFileId: this.testId
                };
                classAwayApi.findWorkPaterNew(params, res => {
                    console.log(res)
                    if(res.data) {
                        this.testPaper =  res.data;
                        if(this.testPaper.gapFillingQuestions.length) {
                            this.testPaper.gapFillingQuestions.forEach((item, index) => {
                                this.$set(this.testPaper.gapFillingQuestions[index], 'stuGapFilling', new Array(this.testPaper.gapFillingQuestions[index].gapFilling.length).fill(''))
                            })
                        }
                        if(this.testPaper.multipleChoiceQuestions.length) {
                            this.testPaper.multipleChoiceQuestions.forEach((item, index) => {
                                if(!item.stuOptionIds) {
                                    this.$set(this.testPaper.multipleChoiceQuestions[index], 'stuOptionIds', [])
                                }
                            })
                        }
                        if(res.data.accuracyRate) {
                            this.accuracyRate = res.data.accuracyRate;
                        }
                        if(res.data.workStatus && res.data.workStatus == '已提交') {
                            this.answerShow = true;
                            this.disabled = true;
                        }
                        //不需要回显答案
                        // if(this.testPaper && this.testPaper.gapFillingQuestions) {
                        //     if(res.data.workStatus && res.data.workStatus == '已提交') {
                        //         return; 
                        //     }
                        //     this.testPaper.gapFillingQuestions.forEach((item, index) => {
                        //         let arr = [];
                        //         arr.length = this.testPaper.gapFillingQuestions[index].blankNum;
                        //         arr.fill('');
                        //         this.$set(this.testPaper.gapFillingQuestions[index], 'stuGapFilling', arr);
                        //     });
                        // }
                        //循环答案
                        if(this.testPaper && this.testPaper.multipleChoiceQuestions) {
                            this.testPaper.multipleChoiceQuestions.forEach((questions, questionsIndex) => {
                                let arr = [];
                                this.testPaper.multipleChoiceQuestions[questionsIndex].optionIds.forEach((item, index) => {
                                    for(var i = 0; i < this.testPaper.multipleChoiceQuestions[questionsIndex].options.length; i++) {
                                        if(item == this.testPaper.multipleChoiceQuestions[questionsIndex].options[i].id) {
                                            console.log(this.optionsMap[i])
                                            arr.push(this.optionsMap[i]);
                                        }    
                                    }
                                    console.log(arr)
                                    this.$set(this.testPaper.multipleChoiceQuestions[questionsIndex], 'succeedOption', arr);
                                })
                            });
                            console.log(this.testPaper.multipleChoiceQuestions)
                        }
                    }
                    this.loadingHide = true;
                })
            }
        },
        //提交作业
        submit() {
            console.log(this.testPaper)
            this.disabled = true;
            let params = {
                classRecordId: this.classRecordId,
                testPaper: this.testPaper
            };

            classAwayApi.submitWorkPaperNew(params, res => {
                if(res.succeed) {
                    this.$message({
                        message: '提交成功',
                        type: 'success'
                    });
                    this.getHomework();
                } else {
                    Toast.fail(res.msg);
                }
            })
            
        },
    }
}
</script>
<style lang="scss">
.homeworkPage {
    padding: 10px 15px;
    background: #fff;
    .testPaperBox {
        padding: 15px 10%;
        margin: 15px auto;
        background: #fff;
        border-radius: 5px;
        box-shadow: 0 15px 15px rgba(0,0,0,.2);
    }
    .el-icon-check {
        color: green;
        font-size: 20px;
        font-weight: 600;
        margin-right: 5px;
    }
    .el-icon-close {
        color: red;
        font-size: 20px;
        font-weight: 600;
        margin-right: 5px;
    }
    img {
        max-width: 100%;
    }
    p {
        max-width: 100%;
        white-space: break-spaces;
    }
    .el-radio {
        display: flex;
        margin-right: 0;
        .el-radio__label {
            display: flex;
            flex: 1;
        }
    }
    .el-checkbox {
        display: flex;
        margin-right: 0;
        .el-checkbox__label {
            display: flex;
            flex: 1;
        }
    }
    .judgeOption {
        .el-radio-group {
            display: flex;
            flex-direction: row;
        }
    }
    h2 {
        text-align: center;
    }
    .score {
        text-align: right;
    }
    .questions {
        display: flex;
        flex-direction: row;
        width: 100%;
    }
    .questions .analysis {
        padding: 5px;
    }
    .questionsTitle {
        display: flex;
        flex-direction: row;
    }
    .questionsTitle span:nth-child(1) {
        margin-right: 5px;
    }
    .questionsTitle span:nth-child(2) {
        display: flex;
        flex-direction: column;
    }
    .questionsTitle span:nth-child(3) {
        white-space: nowrap;
    }
    .successAnswer {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: baseline;
        padding: 5px 0;
        font-weight: 500;
        color: green;
    }
    .judgeSuccessAnswer {
        display: flex;
        flex-direction: column;
        color: green;
        font-weight: 500;
    }
    .judgeSuccessAnswer span {
        font-weight: 500;
    }
    .judgeSuccessAnswer span:nth-child(2),
    .judgeSuccessAnswer span:nth-child(3) {
        text-indent: 1em;
    }
    // span {
    //     display: flex;
    //     font-size: 17px;
    //     font-weight: 600;
    //     letter-spacing: 1px;
    // }
    .singleOption span,
    .multipleOption span {
        text-indent: 1em;
        font-size: 13px;
        font-weight: 500;
    }
    .judgeOption i,
    .judgeOption span {
        text-indent: 1em;
        font-weight: 500;
    }
    .gapFillingOptionBox span {
        white-space: nowrap;
    }
    .colorCheck {
        color: #0080FF;
    }
    .judgeOption i {
        font-size: 22px;
    }
    .gapFillingOptionBox {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
    }
    .questionsBox {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: baseline;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/resource/exercisesResource.vue